export type ThemeColors = {
  primary: string;
  secondary: string;
  text: string;
  background: string;
};

export const applyTheme = (theme: ThemeColors) => {
  const root = document.documentElement;

  root.style.setProperty("--primary", theme.primary);
  root.style.setProperty("--secondary", theme.secondary);
  root.style.setProperty("--foreground", theme.text);
  root.style.setProperty("--background", theme.background);
};

const THEME_KEY = "user-theme";

export const saveTheme = (theme: ThemeColors) => {
  localStorage.setItem(THEME_KEY, JSON.stringify(theme));
};

export const loadTheme = (): ThemeColors | null => {
  const saved = localStorage.getItem(THEME_KEY);
  return saved ? JSON.parse(saved) : null;
};
